import { render, staticRenderFns } from "./amenityForm.vue?vue&type=template&id=4770a32c"
import script from "./amenityForm.vue?vue&type=script&lang=js"
export * from "./amenityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports